import './App.css';
import DashboardComponent from './Dashboard';
import { steps } from './TutorialSteps.js'
import { TourProvider } from '@reactour/tour'

function App() {
  return (
    <TourProvider steps={steps}>
    <DashboardComponent/>
    </TourProvider>
  );
}

export default App;
